import React, { Component } from "react"
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet-async';
import {
    Container,
    Row,
    Col,
    Spinner,
} from "reactstrap"
import MerchantsList from "./MerchantsList"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../components/Common/withRouter";

// Utilities
import {
    createNotificationHelpers,
    loadUninstalledMerchantsData,
    transformUninstalledMerchantsToTableData,
    UNINSTALLED_STORES_TABLE_COLUMNS,
    MESSAGES
} from "../utils";

class UninstalledStores extends Component {
    constructor(props) {
        super(props)
        this.state = {
            TotalMerchants: 0,
            MerchantsDetails: { columns: UNINSTALLED_STORES_TABLE_COLUMNS, rows: [] },
            loading: true
        }

        // Initialize notification helpers
        const notifications = createNotificationHelpers();
        this.notify_info = notifications.notify_info;
        this.notify_error = notifications.notify_error;
        this.notify_success = notifications.notify_success;
    }

    /**
     * Navigates to merchant details page
     */
    navigateToMerchantDetails = (merchant) => {
        this.props.navigate("/merchant-details", { state: { data: merchant, storeStatus: 'inactive' } });
    }

    /**
     * Loads uninstalled merchants from API and updates state
     */
    loadUninstalled = async () => {
        this.setState({ loading: true });

        const merchants = await loadUninstalledMerchantsData(this.notify_error);

        if (merchants && Array.isArray(merchants) && merchants.length > 0) {
            const data = transformUninstalledMerchantsToTableData(
                merchants,
                UNINSTALLED_STORES_TABLE_COLUMNS,
                this.navigateToMerchantDetails
            );

            this.setState({
                TotalMerchants: merchants.length,
                MerchantsDetails: data,
                loading: false
            });

            this.notify_success(MESSAGES.UNINSTALLED_STORES_LOADED_SUCCESS);
        } else if (merchants && Array.isArray(merchants)) {
            // Empty array - no merchants found
            this.setState({
                TotalMerchants: 0,
                MerchantsDetails: { columns: UNINSTALLED_STORES_TABLE_COLUMNS, rows: [] },
                loading: false
            });
            this.notify_info("No uninstalled stores found");
        } else {
            // Error or null response
            this.setState({
                MerchantsDetails: { columns: UNINSTALLED_STORES_TABLE_COLUMNS, rows: [] },
                loading: false
            });
        }
    }

    componentDidMount() {
        this.loadUninstalled();
    }

    /**
     * Renders the loading spinner
     */
    renderLoadingSpinner = () => (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '40px' }}>
            <Spinner color="primary" />
            <span style={{ marginLeft: '10px' }}>Loading ...</span>
        </div>
    )

    render() {
        const { MerchantsDetails, loading } = this.state;
        const { t } = this.props;

        return (
            <React.Fragment>
                <div className="page-content">
                    <Helmet>
                        <title>Veeper | AP - Stores</title>
                    </Helmet>
                    <Container fluid>
                        <Breadcrumbs
                            title={t("Ex-Stores")}
                            breadcrumbItem={t("Ex-Stores")}
                        />
                        <ToastContainer />
                        <Row>
                            <Col xl={12}>
                                {loading ? (
                                    this.renderLoadingSpinner()
                                ) : (
                                    <MerchantsList data={MerchantsDetails} />
                                )}
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}

UninstalledStores.propTypes = {
    t: PropTypes.any,
    navigate: PropTypes.func
}

export default withRouter(withTranslation()(UninstalledStores))